import { api, dashboardApi, catchHandler, catchHandlerForPaymentIntent } from '../../helpers/axios'
import config from '../../config'
import { objToUrlParams } from '../../helpers/utility'
import * as attributes from '../../config/query-attributes'

export function getInoivceList(payload) {
  return api()
    .get(
      `${config.routes.listInvoices}?${objToUrlParams(payload)}&showBookingInvoice=true&attributes=${
        attributes.invocieAttributes
      }`
    )
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getPlaidLinkToken(payload) {
  return api()
    .get(`${config.routes.getPlaidLinkToken}/` + payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function stripeACHPayment(payload) {
  return api()
    .post(config.routes.stripeACHPayment, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getPaymentList(payload) {
  return api()
    .get(`${config.routes.paymentList}?${objToUrlParams(payload)}&attributes=${attributes.paymentHistoryAttributes}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getAllCards(payload) {
  return api()
    .get(`${config.routes.cardconnectCards}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getAllStripeCards(payload) {
  const cusID = payload[0]
  const url = config.routes.getStripeCards + '/' + cusID
  return api()
    .get(url)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getSMBStripeCustomerID(payload) {
  return api()
    .post(config.routes.getSMBStripeCustomerID, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getPlatformCustomerId(payload) {
  return api()
    .post(config.routes.getPlatformCustomerId, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function addCard(payload) {
  return api()
    .post(config.routes.cardconnectCards, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function setDefaultCard(payload) {
  return api()
    .post(config.routes.cardconnectDefault, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function proceedPayment(payload) {
  return api()
    .post(config.routes.payment, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function createUserReview(payload) {
  return dashboardApi()
    .post(config.routes.createReview, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getPaymentIntent(payload) {
  return api()
    .post(`${config.routes.paymentIntent}`, payload)
    .then((result) => result.data)
    .catch((error) => catchHandlerForPaymentIntent(error.response.data))
}

export async function proceedPreStripePayment(payload) {
  try {
    const res = await api().post(config.routes.prePayment, payload)
    return res.data
  } catch (e) {
    return catchHandler(e)
  }
}

export function proceedPostStripePayment(payload) {
  return api()
    .post(config.routes.postPayment, payload)
    .then((response) => response.data)
    .catch((error) => catchHandlerForPaymentIntent(error.response.data))
}

export function removeCard(payload) {
  return api()
    .delete(config.routes.cardconnectCards, { data: payload })
    .then((res) => res.data)
    .catch(catchHandler)
}

export function removeStripeCard(payload) {
  const platform_customer_id = payload[0]
  const paymentMethod = payload[1]
  const url = config.routes.deleteStripeCards + '/' + platform_customer_id + '/' + paymentMethod
  return api()
    .delete(url)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function addPaymentTip(payload) {
  return api()
    .post(config.routes.addTip, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function handleEditCardconnectCard(payload) {
  return api()
    .put(config.routes.cardconnectCards, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getBusinessList(payload) {
  return api()
    .get(`${config.routes.userBusiness}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function offlineActivity(payload) {
  return api()
    .post(config.routes.offline, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getUserPaymentType(payload) {
  return api()
    .get(`${config.routes.paymentType}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getPaymentReceipt(payload) {
  return api()
    .get(`${config.routes.getReceipt}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getInoivceById(payload) {
  return api()
    .get(`${config.routes.invoice}/${payload.invoiceId}?attributes=${attributes.invocieAttributes}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function trackTransactionStatusChange(payload) {
  return api()
    .post(config.routes.trackTransactionStatusChange, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function failedTransaction(payload) {
  return dashboardApi()
    .post(config.routes.failedTransaction, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getMerchantId(payload) {
  return api()
    .get(`${config.routes.getMerchantId}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getBusinessOwnerInfo(payload) {
  return dashboardApi()
    .get(`${config.routes.businessOwner}/${payload}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getBusinessType(payload) {
  return dashboardApi()
    .get(`${config.routes.bussinessTypes}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getACHConfFlag(payload) {
  return dashboardApi()
    .post(config.routes.getAchConfigFlag, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getFeatureFlags(payload) {
  return dashboardApi()
    .post(config.routes.getFeatureFlags, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getPlaidAccessToken(payload) {
  return dashboardApi()
    .post(config.routes.plaidAccessToken, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getBanking(payload) {
  return dashboardApi()
    .get(`${config.routes.getbanking}?${objToUrlParams(payload)}`)
    .then((res) => res.data)
    .catch(catchHandler)
}
export function getAchToken(payload) {
  return api()
    .post(`${config.routes.getAchToken}`, payload)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getEstimateDashboardToken() {
  return api()
    .get(`${config.routes.getEstimateDashboardToken}`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function createWisetackTransactionForInvoice(invoiceId) {
  return api()
    .post(`/invoices/${invoiceId}/wisetack-transaction`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getPromotionalDetailsForInvoice(invoiceId) {
  return api()
    .get(`/invoices/${invoiceId}/promotional-details`)
    .then((res) => res.data)
    .catch(catchHandler)
}

export function getMerchantWisetackApplicationStatus(invoiceId) {
  return api()
    .get(`/invoices/${invoiceId}/merchant-wisetack-application-status`)
    .then((res) => res.data)
    .catch(catchHandler)
}
